import { useState } from 'react';
import { makeStyles, Grid, Box, Dialog, Divider, withStyles, Button, Theme, createStyles, TextField } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { editUser } from "../../../../store/actions/admin/user";
import { useDispatch, useSelector } from "react-redux";
import ValidateForm from "../../../../helper/validations";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px!important'
  },
  createBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#0179EE',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0f9fef'
    },
  },
  cancelBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#e0e0e0',
    },
  },


}));

const EditUserModel = ({ open, onClose, userId, firstName, lastName }: any) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  const [state, setState] = useState({
    firstName: firstName,
    lastName: lastName,
    userId: userId,
    loading: false,
    errors: { firstname: "", lastname: "", username: "" },
  });


  //Method call on create role button
  const onAddUser = () => {

    const request = {
      firstname: state.firstName,
      lastname: state.lastName,
      user_id: parseFloat(state.userId),
    };
    
    const validateError = ValidateForm.validateEditUserForm(request)
    if (!Object.keys(validateError).length) {
      setState(prevState => ({
        ...prevState,
        "loading": true
      }));
      const request = {
        first_name: state.firstName,
        last_name: state.lastName,
        user_id: parseFloat(state.userId),
        customer_name: loginUserData.customer_name,
      };
      dispatch(editUser(apolloClient.client, request));
      onClose()

    } else {
      setState(prevState => ({
        ...prevState,
        errors: validateError
      }));
    }


  };

  // Call method on input change
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const errors = state.errors;

    if (value === "") {
      if (name === "firstName") {
        errors["firstname"] = "Please enter your first name";
      }
    } else if (value !== "" && name === "firstName") {
      errors["firstname"] = ""
    }

    if (value === "") {
      if (name === "lastName") {
        errors["lastname"] = "Please enter your last name";
      } else { errors["lastname"] = "" }
    } else if (value !== "" && name === "lastName") {
      errors["lastname"] = ""
    }
    // if (value === "") {
    //   if (name === "username") {
    //     errors["username"] = "Please enter your email";
    //   } else { errors["username"] = "" }
    // } else if (value !== "" && name === "username") {
    //   errors["username"] = ""
    // }
    setState(prevState => ({
      ...prevState,
      [name]: value,
      errors: {
        ...state.errors,
        firstname: errors["firstname"],
        lastname: errors["lastname"],
        // username: errors["username"],
      },
    }));
  };


  const DialogTitle = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <div className={classes.header}>
          {children}
          {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
            </IconButton>
          ) : null}
        </div>
      </MuiDialogTitle>
    );
  });

  return (
    <div>
      <Grid container>
        <Grid item>
          <Dialog
            
            disableEscapeKeyDown
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            className="modal-custom"
            scroll="body"
          >
            <div>
              <DialogTitle onClose={onClose}>
                Edit a user
        			</DialogTitle>
              <Divider />

              <Box m={4} pl={1} pr={1}>
                <TextField
                  value={state.firstName}
                  fullWidth
                  margin="normal"
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  onChange={(e) => handleChange(e)}
                  error={state.errors && state.errors.firstname ? true : false}
                  helperText={state.errors.firstname ? state.errors.firstname : ""}
                />
                <TextField
                  value={state.lastName}
                  fullWidth
                  margin="normal"
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  onChange={(e) => handleChange(e)}
                  error={state.errors && state.errors.lastname ? true : false}
                  helperText={state.errors.lastname ? state.errors.lastname : ""}
                />
                {/* <TextField
                  value={state.username}
                  fullWidth
                  margin="normal"
                  id="username"
                  label="Email"
                  name="username"
                  onChange={(e) => handleChange(e)}
                  error={state.errors && state.errors.username ? true : false}
                  helperText={state.errors.username ? state.errors.username : ""}
                /> */}

              </Box>
              <Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
                <Button onClick={onClose}>
                  Cancel
								</Button>&nbsp;&nbsp;&nbsp;
                <Button
                  onClick={() => onAddUser()}
                  disabled={state.loading ? true : false}
                  className={classes.createBtn}
                >
                  Update
								</Button>
              </Box>
            </div>
          </Dialog>
        </Grid>
      </Grid>
    </div>
  )
}
export default EditUserModel;

